/* eslint-disable quotes */
export const AbrExampleByAcn = {
    "SearchByASICv201408Response": {
        "result": "SearchByASICv201408Result",
        "SearchByASICv201408Result": {
            "@id": "id1",
            "Request": {
                "@id": "id2",
                "ExternalRequestBody": {
                    "@id": "id3",
                    "AuthenticationGUID": "e9959e02-eccd-40c6-be26-7d1a19267b95",
                    "IdentifierType": "ASIC",
                    "IdentifierValue": "051775556",
                    "History": "N"
                }
            },
            "Response": {
                "@id": "id4",
                "UsageStatement": "The Registrar of the ABR monitors the quality of the information available on this website and updates the information regularly. However, neither the Registrar of the ABR nor the Commonwealth guarantee that the information available through this service (including search results) is accurate, up to date, complete or accept any liability arising from the use of or reliance upon this site.",
                "DateRegisterLastUpdated": "2023-09-06T00:00:00",
                "DateTimeRetrieved": "2023-09-06T17:16:43.1771136+10:00",
                "ResponseBody": {
                    "@id": "id5",
                    "RecordLastUpdatedDate": "2023-07-02T00:00:00",
                    "ABN": {
                        "@id": "id6",
                        "@itemType": "types:Identifier",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id7",
                            "IdentifierValue": 33051775556,
                            "IsCurrentIndicator": "Y",
                            "ReplacedFrom": "0001-01-01T00:00:00"
                        }
                    },
                    "EntityStatus": {
                        "@id": "id8",
                        "@itemType": "types:EntityStatus",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id9",
                            "EntityStatusCode": "Active",
                            "EffectiveFrom": "1999-11-01T00:00:00",
                            "EffectiveTo": "0001-01-01T00:00:00"
                        }
                    },
                    "ASICNumber": "051775556",
                    "EntityType": {
                        "@id": "id10",
                        "EntityTypeCode": "PUB",
                        "EntityDescription": "Australian Public Company"
                    },
                    "GoodsAndServicesTax": {
                        "@id": "id11",
                        "@itemType": "types:GoodsAndServicesTax",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id12",
                            "EffectiveFrom": "2000-07-01T00:00:00",
                            "EffectiveTo": "0001-01-01T00:00:00"
                        }
                    },
                    "Name": {
                        "@id": "id13",
                        "@itemType": "xsd:anyType",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id14",
                            "OrganisationName": "TELSTRA CORPORATION LIMITED",
                            "EffectiveFrom": "2000-01-20T00:00:00"
                        }
                    },
                    "MainTradingName": {
                        "@id": "id15",
                        "@itemType": "types:OrganisationName",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id16",
                            "OrganisationName": "TELSTRA",
                            "EffectiveFrom": "2000-01-20T00:00:00"
                        }
                    },
                    "OtherTradingName": {
                        "@id": "id17",
                        "@itemType": "types:OrganisationName",
                        "@arraySize": 3,
                        "Item": [
                            {
                                "@id": "id18",
                                "OrganisationName": "TELSTRA CORPORATION LIMITED",
                                "EffectiveFrom": "2000-09-12T00:00:00"
                            },
                            {
                                "@id": "id19",
                                "OrganisationName": "TELSTRA CORPORATION LIMITED",
                                "EffectiveFrom": "2000-07-21T00:00:00"
                            },
                            {
                                "@id": "id20",
                                "OrganisationName": "TELSTRA",
                                "EffectiveFrom": "2000-04-26T00:00:00"
                            }
                        ]
                    },
                    "MainBusinessPhysicalAddress": {
                        "@id": "id21",
                        "@itemType": "types:AddressDetails",
                        "@arraySize": 1,
                        "Item": {
                            "@id": "id22",
                            "StateCode": "VIC",
                            "Postcode": 3000,
                            "EffectiveFrom": "2022-01-19T00:00:00",
                            "EffectiveTo": "0001-01-01T00:00:00"
                        }
                    },
                    "BusinessName": {
                        "@id": "id23",
                        "@itemType": "types:OrganisationName",
                        "@arraySize": 10,
                        "Item": [
                            {
                                "@id": "id24",
                                "OrganisationName": "TELSTRA INFRACO",
                                "EffectiveFrom": "2023-03-17T00:00:00"
                            },
                            {
                                "@id": "id25",
                                "OrganisationName": "AUTOMOTIVE ALLIANCE",
                                "EffectiveFrom": "2011-09-05T00:00:00"
                            },
                            {
                                "@id": "id26",
                                "OrganisationName": "SPECIALISED RECOVERIES",
                                "EffectiveFrom": "2007-12-12T00:00:00"
                            },
                            {
                                "@id": "id27",
                                "OrganisationName": "NETWORKING TASMANIA",
                                "EffectiveFrom": "2005-02-28T00:00:00"
                            },
                            {
                                "@id": "id28",
                                "OrganisationName": "TELSTRA'S KIDS FUND",
                                "EffectiveFrom": "2002-04-08T00:00:00"
                            },
                            {
                                "@id": "id29",
                                "OrganisationName": "TELSTRA BUSINESS SHOP",
                                "EffectiveFrom": "2002-01-21T00:00:00"
                            },
                            {
                                "@id": "id30",
                                "OrganisationName": "TELECOM AUSTRALIA",
                                "EffectiveFrom": "1999-11-01T00:00:00"
                            },
                            {
                                "@id": "id31",
                                "OrganisationName": "TELSTRA SHOP",
                                "EffectiveFrom": "1999-11-01T00:00:00"
                            },
                            {
                                "@id": "id32",
                                "OrganisationName": "WHEREIS",
                                "EffectiveFrom": "1999-11-01T00:00:00"
                            },
                            {
                                "@id": "id33",
                                "OrganisationName": "YELLOW PAGES",
                                "EffectiveFrom": "1999-11-01T00:00:00"
                            }
                        ]
                    }
                }
            }
        }
    }
};